import React from 'react';

import './nodata.scss';

export default function NoData(props) {
    const message = props && props.message && typeof props.message === 'string' ? props.message : null;
    return (
        <div className="no-data">
            <h2>No results</h2>
            {(message) && (
                <p>{message}</p>
            ) }
            {!(message) && (
                <p>The requested organization has no devices.</p>
            ) }
        </div>
    );
}
